<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>抄表记录</span>
    </div>
    <div class="table-info">
      <img :src="infoObj.img" mode="" />
      <div>
        <span
          >{{ infoObj.instrumentationName }}
          {{ infoObj.instrumentationNumber }}</span
        >
        <span>{{ infoObj.area }}</span>
        <span>上次抄表时间：{{ infoObj.lastDate }}</span>
      </div>
    </div>
    <div class="detail-content">
      <div
        class="detail-info"
        v-for="(item, index) in detailData.records"
        :key="index"
      >
        <div>
          <span>抄表时间：{{ item.currentDate }}</span>
          <span>抄表人：{{ item.meterReadingPerson }}</span>
        </div>
        <div>
          <span>本次读数：{{ item.currentValue }}</span>
          <span>抄表用量：{{ item.dosageMeterReading }}</span>
        </div>
      </div>
    </div>
    <!-- 抄表按钮 -->
    <div class="followBtn" v-if="currentPermission.rwAccessStatus==2">
      <a-button type="primary" @click="newCopy">抄表</a-button>
    </div>
    <a-modal
      title="抄表"
      :visible="visible"
      :confirm-loading="false"
      ok-text="确定"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="visible = false"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item
          ref="currentValue"
          label="抄表读数："
          prop="currentValue"
        >
          <a-input v-model="form.currentValue" placeholder="请输入抄表读数" style="width:300px" />
        </a-form-model-item>
        <a-form-model-item
          ref="meterReadingDate"
          label="抄表日期："
          prop="meterReadingDate"
        >
          <a-date-picker
            placeholder="选择时间"
            style="width:300px"
            :locale="locale"
            show-time
            @change="onChange"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { getCopyDetail, addRecord } from "../axios/property";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  data() {
    return {
      locale,
      visible: false, // 抄表弹框
      labelCol: { span: 4 },
      wrapperCol: { span: 9 },
      form: {
        currentValue: "",
        meterReadingDate: "",
      },
      rules: {
        currentValue: [
          { required: true, message: "请输入抄表读数", trigger: "blur" },
        ],
        meterReadingDate: [
          { required: true, message: "请选择抄表日期", trigger: "change" },
        ],
      },
      infoObj: {},
      detailData: {},
      companyId: "", // 公司id
      currentPermission: {}, // 权限信息
    };
  },
  created() {
    this.infoObj = this.$route.params.obj;
    this.companyId = this.$store.state.initialData.companyId;
    console.log(this.$store.state.initialData.currentPermission)
    this.currentPermission = this.$store.state.initialData.currentPermission
    this.getDetailData();
  },
  methods: {
    getDetailData() {
      // 获取列表数据
      console.log(this.$route.params.obj);
      let data = {
        companyId: this.companyId,
        instrumentationId: this.infoObj.instrumentationId,
      };
      getCopyDetail(data).then((res) => {
        console.log(res);
        let responseData = res.data.data;
        for (let i = 0; i < responseData.records.length; i++) {
          if (responseData.records[i].currentDate) {
            responseData.records[i].currentDate = new Date(
              responseData.records[i].currentDate
            ).toLocaleString("chinese", { hour12: false });
          }
        }
        this.detailData = responseData;
      });
    },
    backPage() {
      // 回退页面
      this.$router.push("/copy-list");
    },
    newCopy() {
      // 新增抄表
      this.form.currentValue = "";
      this.form.meterReadingDate = "";
      this.visible = true;
    },
    onChange(value, dateString) {
      // 日期选择改变时
      console.log(value, dateString);
      this.form.meterReadingDate = dateString;
    },
    handleOk() {
      // 抄表表单点击确定
      let that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = {
            instrumentationId: this.infoObj.instrumentationId,
            ...this.form,
          };
          addRecord(data).then((res) => {
            let responseData = res.data;
            if (responseData.code == 0) {
              that.$message.success("抄表成功");
              that.$router.push("/copy-list");
            } else {
              that.$message.error("操作失败");
              that.visible = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
  position: relative;
  padding-bottom: 0.8rem;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.2rem 0.3rem;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
.table-info {
  display: flex;
  padding: 0.3rem 0.1rem;
  align-items: center;
  background-color: white;
  border-top: 1px solid #f9f9f9;
  box-shadow: 0px 4px 8px 0px #e5e5e5;
}
.table-info img {
  width: 2rem;
  height: 2rem;
  margin: 0 0.2rem;
}
.table-info div {
  display: flex;
  flex-direction: column;
  line-height: 0.6rem;
  margin-left: 0.1rem;
}
.table-info div span:nth-child(1) {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
}
.table-info div span:nth-child(2) {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.table-info div span:nth-child(3) {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
}
.detail-content {
  padding: 0.4rem;
}
.detail-info {
  background-color: white;
  padding: 0.3rem 0.4rem;
  border-radius: 8px;
  margin-bottom: 0.5rem;
}
.detail-info div {
  display: flex;
  font-size: 15px;
}
.detail-info div:nth-child(1) {
  margin-bottom: 0.1rem;
}
.detail-info div span:nth-child(1) {
  margin-right: auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.detail-info div span:nth-child(2) {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
/* 跟进按钮 */
.followBtn {
  padding: 0.2rem 0.3rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
}
.followBtn /deep/.ant-btn {
  width: 100%;
}
</style>
